import SceneProperties from "../data/SceneProperties";

class BulletModel {
    bottom:number;
    left:number;
    height:number;
    width:number;

    constructor(left:number) {
        this.bottom = 86.5 / 100 * window.innerHeight;
        this.left = left / 100 * document.body.clientWidth * SceneProperties.totalWidthFact;
        this.height = 1.5 / 100 * window.innerHeight;
        this.width = SceneProperties.bulletWidth;
    }
}

export default BulletModel;